import img from "core/assets/img/nft-friendship.jpg";
import { V4Mints } from "pages/MintNft/components/V4Mints";

export const ImbuedWithFriendship = () => <V4Mints img={img} actualEdition={4}/>;